import lodash from "lodash";
import store from "../../../../../store";
//import { createButtonCreate } from "../../../../../utils/button";
import { conditionFormChecker, /*onClickDeleteAllClient,*/ putField } from "../../../../../utils/form";
import { createLoading } from "../../../../../utils/loading";
import { /*createManageDelete, createManageExportCsv,*/ createPage } from "../../../../../utils/page";
import {
    createFieldCheckbox,
    createFieldTemplateBuilder,
} from "../../../../../components/input/template-builder/template-builder.logic";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/hazDiscussPictogram";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });

export const createField = ({ props, data, key /* , isLoading */ }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldTemplateBuilder({
                colProp: () => ({ xs: 24 }),
                inputProp: () => {
                    const fields = data.pictograms.map((pictogram, index) =>
                        createFieldCheckbox({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}${index}.refPictogram`,
                            colProp: () => ({ xs: 8 }),
                            formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                            label: () => pictogram.name,
                            labelRender: () => "",
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        checked: !!model.filter(d => d.isDelete !== true).find(d => d.refPictogram?.id === pictogram.id),
                                        "onUpdate:checked": checked => {
                                            const valueIndex = model.findIndex(d => d.refPictogram?.id === pictogram.id);
                                            const value = model.find(d => d.refPictogram?.id === pictogram.id);
                                            if (checked) {
                                                if (value) {
                                                    value.isSave = true;
                                                    value.isDelete = false;
                                                } else {
                                                    model.push({ refPictogram: pictogram });
                                                }
                                            } else {
                                                if (value.id) {
                                                    value.isSave = false;
                                                    value.isDelete = true;
                                                } else {
                                                    model.splice(valueIndex, 1);
                                                }
                                            }
                                        },
                                        disabled: viewOnly,
                                        text: () => pictogram.name
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        })
                    );
                    return { useForm, fields, skeleton: isLoading.value };
                }
            }),
        ]
    });
};

export const initData = ({ props, data }) => {
    const { /*menuContext, viewOnly,*/ itemsKey, /*canCreate, canDelete*/ } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    data.page = createPage({ data: items });
    data.fields = createField({ props, data, key: itemsKey });
    fetchData({ props, data }).then(page => items.push(...page.data));
};

export const fetchData = ({ props }) => {
    const { fetchCriteria } = props;
    if (!fetchCriteria || fetchCriteria.fetched) {
        return Promise.resolve({ data: [] });
    }
    fetchCriteria.fetched = true;
    setIsLoading(true);
    return callSearch({ criteria: fetchCriteria }).finally(() => setIsLoading(false));
};
